import React from "react";
import { useNavigate } from "react-router-dom";
import ArrowLeft from "../../components/icons/ArrowLeft";
import PolicyWrapper from "../../assets/wrappers/Policy";

const DataDeletion = () => {
  const navigate = useNavigate();
  const goBack = () => {
    navigate("/");
  };
  return (
    <PolicyWrapper>
      <div className="back">
        <i>
          <ArrowLeft
            onClick={goBack}
            width={48}
            height={40}
            viewBox="0 0 24 20"
          />
        </i>
      </div>
      <div className="header">
        <h1>User Data Deletion Instructions</h1>
      </div>
      <div className="content">
        <div className="txt">
          <p>
            If you would like to delete your data associated with our
            application, please send an email to: support@proad.live
          </p>

          <p>
            Please include your Facebook User ID and the email used to log in.
          </p>

          <p>We will process your request within 7 business days.</p>
        </div>
      </div>
    </PolicyWrapper>
  );
};

export default DataDeletion;
